<template>
  <div class="fill-height">
    <template v-if="isLoading">
      <v-container class="fill-height">
        <v-row
          align="center"
          justify="center"
        >
          <v-progress-circular
            :size="80"
            color="accent"
            :width="8"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </v-container>
    </template>
    <template v-else>
      <documents-toolbar
        @onRefresh="loadData"
      />
      <v-container style="padding-top: 56px;">
        <v-row v-for="(documents, storeId) in filteredRecords" :key="storeId" dense>
          <v-col v-if="documents.length">
            <p class="title mb-0 mt-4"><v-icon color="primary" class="mb-1">mdi-inbox-multiple</v-icon>{{_getStoreName(storeId)}}</p>
          </v-col>
          <v-col
            v-for="(document, i) in documents"
            :key="i"
            :class="{'pt-0' : i === 0}"
            cols="12">
            <document-card
              :document="document"
              :currencies="currencies"
              @removeCard="removeCard"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'
import documentsToolbar from './documentsToolbar'
import RegionsApi from '../api'
import { mapValues, toLower } from 'lodash'
import documentCard from 'app/document/components/documentCard'

export default {
  name: 'regionDocuments',
  components: {
    documentsToolbar,
    documentCard
  },
  data () {
    return {
      isLoading: false,
      records: {},
      currencies: []
    }
  },
  computed: {
    ...mapGetters('regions', {
      _getStoreName: 'getStoreName'
    }),
    ...mapMultiRowFields('regions', {
      _stores: 'stores'
    }),
    ...mapFields('regions', {
      _searchTerm: 'searchTerm',
      _showLoadedOnly: 'showLoadedOnly'
    }),
    ...mapFields('tradle', {
      _messageBar: 'messageBar',
      _messageText: 'messageText',
      _messageType: 'messageType'
    }),
    filteredRecords () {
      let selectedStores = this._stores.filter(record => record.selected).map(record => record.id)
      let filteredByStore = Object.keys(this.records)
        .filter(key => selectedStores.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.records[key]
          return obj
        }, {})
      if (this._searchTerm) {
        filteredByStore = mapValues(filteredByStore, (documents) => {
          return documents.filter((record) => toLower(record.doc_id).includes(toLower(this._searchTerm)) || toLower(record.kontragenti_name).includes(toLower(this._searchTerm)))
        })
      }
      if (this._showLoadedOnly) {
        filteredByStore = mapValues(filteredByStore, (documents) => {
          return documents.filter((record) => record.process === 3)
        })
      }
      return filteredByStore
    }
  },
  methods: {
    async loadData () {
      this.isLoading = true
      let response = await RegionsApi.getDocuments()
      this.records = response.data
      this.currencies = response.currencies
      let stores = Object.keys(this.records)
      stores.forEach(storeId => {
        this._stores.find(record => record.id === storeId).active = true
      })
      this.isLoading = false
    },
    removeCard (skladiId, docId, docName) {
      let idx = this.records[skladiId].findIndex((record) => record.doc_id === docId && record.name === docName)
      this.records[skladiId].splice(idx, 1)
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
</style>
